class Customer.DefinitionsRepository

  constructor: (raw_definitions) ->
    @raw_definitions = raw_definitions

  all_definitions: ->
    return @definitions if @definitions
    @definitions = {}
    _.each @raw_definitions, (raw_definition) =>
      @definitions[raw_definition.definition.code] = new Customer.ConversationAttribute.Definition(raw_definition.definition)
    @definitions

  get_definition_for_code: (code) ->
    definitions = @all_definitions()
    definitions[code]
